'use es6';

import quickFetch from 'quick-fetch';
import * as earlyRequestUtils from './earlyRequestUtils';
import { makeEarlyRequestEntries, makeNativeStatusRequestEntries, makeAppInstallsEntries } from './earlyRequests';
import { treatmentsClient } from '../modules/settings/api/ExperimentApi';
treatmentsClient.resolve();
import { earlyRequestHubsSettings } from 'frontend-preferences-client/quickFetch';
import { ALL_PORTAL_SETTINGS_KEYS } from '../modules/PortalSettings/PortalSettingsKeys';
export const hubsSettingsEarlyRequestName = 'portal-setting-early-request';
const makeRequest = request => {
  if (request.regex && !request.regex.test(window.location.href) || request.condition && !request.condition()) {
    return;
  }
  quickFetch.makeEarlyRequest(request.key, {
    url: quickFetch.getApiUrl(typeof request.url === 'function' ? request.url() : request.url, true),
    type: request.type || 'GET',
    dataType: 'json',
    data: request.body && JSON.stringify(request.body),
    timeout: request.timeout || 14000
  });
};
(function () {
  const isQA = window.location.hostname.indexOf('hubspotqa') > -1;
  const [__, portalId, appId] = earlyRequestUtils.extractIds(document.location.pathname);
  const query = earlyRequestUtils.reduceQueryParams(document.location.search.slice(1));
  const earlyRequests = makeEarlyRequestEntries({
    portalId,
    appId,
    query
  });
  const nativeStatusRequests = makeNativeStatusRequestEntries(appId);
  earlyRequests.forEach(makeRequest);
  quickFetch.afterAuth(authData => {
    const scopes = authData.user.scopes;
    const appInstallsRequests = makeAppInstallsEntries(scopes);
    appInstallsRequests.forEach(makeRequest);
  });
  nativeStatusRequests.forEach(request => {
    if (request.regex && !request.regex.test(window.location.pathname)) {
      return;
    }
    const requestAppId = isQA ? request.qaId : request.prodId;
    quickFetch.makeEarlyRequest(`integration-status-${requestAppId}`, {
      url: quickFetch.getApiUrl('/appinstalls/v3/app-install/native-app-connection-status', true),
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify({
        appIds: [requestAppId],
        businessUnitId: query.businessUnitId
      }),
      timeout: request.timeout || 14000
    });
  });
  earlyRequestHubsSettings(ALL_PORTAL_SETTINGS_KEYS, hubsSettingsEarlyRequestName);
})();